import { LEFT_SWITCH, RIGHT_SWITCH } from "../actions/types";
const initialState = {
	isLeft: true
};
export default function(state = initialState, action) {
	switch (action.type) {
		case LEFT_SWITCH:
			return {
				...state,

				isLeft: true
			};
		case RIGHT_SWITCH:
			return {
				...state,

				isLeft: false
			};

		default:
			return state;
	}
}
